<form class="search-form" data-application="search-form" (ngSubmit)="performSearch()">
    <website-input-v2
        #inputElement
        name="search"
        type="search"
        [maxLength]="255"
        [size]="inputSize()"
        [labelText]="inputPlaceholder()"
        [(ngModel)]="searchInputValue"
        (receiveInputValue)="performSearch()"
    ></website-input-v2>
</form>
